// extracted by mini-css-extract-plugin
module.exports = {"root":"_d90cb9","iconContainer":"_34c2fd","icon":"_883ba5","primary":"_2440a0","light":"_d1e984"};